import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { emptyCart } from "../redux/reducers/cartSlice";
import { createOrder, getUserOrder } from "../redux/reducers/orderSlice";

const PaymentSuccessful = () => {
  document.title = "Congratulations on your payment";
  const { userInfo, userToken } = useSelector((state) => state.auth);
  const { userCartItems, cartItems, amountTotal } = useSelector(
    (state) => state.cart
  );
  const { success, loading, error } = useSelector((state) => state.order);
  const { addresses } = useSelector((state) => state.address);

  const dispatch = useDispatch();
  const paymentID = localStorage.getItem("paymentID");
  const paymentMethod = localStorage.getItem("paymentMethod");
  const codAdvance = parseFloat(localStorage.getItem("codAdvance") || "0");
  const codRemaining = parseFloat(localStorage.getItem("codRemaining") || "0");

  useEffect(() => {
    if (userInfo && addresses.length > 0) {
      const userId = userInfo.id || userInfo._id;
      dispatch(getUserOrder({ user: userId }));
      dispatch(
        createOrder({
          user: userId,
          paymentID,
          paymentMethod: paymentMethod || 'paypal',
          advanceAmount: paymentMethod === 'cod' ? codAdvance : null,
          remainingAmount: paymentMethod === 'cod' ? codRemaining : null,
          products: cartItems,
          amount: amountTotal,
          address:
            addresses.filter((address) => address.checked).length > 0
              ? addresses.filter((address) => address.checked)[0]
              : addresses[0],
        })
      );
    }
    // eslint-disable-next-line
  }, [userInfo, addresses]);

  useEffect(() => {
    if (userInfo && addresses.length > 0) {
      // EMPTY CART AFTER CREATING  ORDER FOR USER
      success && dispatch(emptyCart());
    }
    // IF IT'S A UNREGISTERED/NON-USER
    if (!userToken) {
      dispatch(emptyCart());
    }
    // eslint-disable-next-line
  }, [success, userCartItems.length > 0, cartItems.length > 0]);

  return (
    <section className="h-auto pt-2 min-h-[80vh] flex justify-center text-center">
      <div className="max-w-xl sm:max-w-4xl lg:max-w-7xl relative px-5 pt-20 pb-12 items-center mx-auto lg:mx-20 xl:mx-28 2xl:mx-40 3xl:mx-auto lg:pb-2 lg:px-1 xl:px-3 2xl:px-1">
        <span className="flex items-center justify-center h-12 w-12 relative m-auto">
          <span className="animate-[ping_1s_ease-in-out_infinite] absolute inline-flex h-full w-full rounded-full bg-pale-orange opacity-75"></span>
          <span className="animate-[ping_1s_ease-in-out_infinite] absolute inline-flex h-3/4 w-3/4 rounded-full bg-pale-orange opacity-75"></span>
          <span className="relative inline-flex rounded-full h-12 w-12 bg-pale-orange justify-center items-center text-2xl font-bold text-very-dark-blue">
            <ion-icon name="checkmark"></ion-icon>
          </span>
        </span>
        <h3 className="text-xl leading-6 font-bold text-gray-900 mt-12">
          Payment Successful!
        </h3>
        
        {/* COD Payment Info */}
        {paymentMethod === 'cod' && codRemaining > 0 && (
          <div className="mt-6 max-w-md mx-auto bg-amber-50 border border-amber-200 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <svg className="w-6 h-6 text-amber-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
              <div className="flex-1 text-left">
                <h4 className="font-semibold text-amber-900 mb-2">Cash on Delivery</h4>
                <div className="space-y-1 text-sm text-amber-800">
                  <p>Advance Paid: <span className="font-semibold">₹{codAdvance.toFixed(2)}</span></p>
                  <p className="font-bold text-base">Pay on Delivery: ₹{codRemaining.toFixed(2)}</p>
                </div>
              </div>
            </div>
          </div>
        )}
        
        {userInfo ? (
          <>
            {!error ? (
              <>
                {loading ? (
                  <>
                    <p className="text-grayish-blue">
                      Please hold while order is being created...
                    </p>
                  </>
                ) : (
                  <div className="mt-8">
                    <p className="text-grayish-blue mb-8">
                      Congratulation on your order. Check your orders in your
                      profile.
                    </p>
                    <Link to="/user-profile/orders">
                      <button className="w-full max-w-xs m-auto bg-orange border border-orange rounded-md py-3 px-4 text-base font-medium text-white shadow-[inset_0_0_0_0_#ffede0] hover:shadow-[inset_0_-4rem_0_0_#ffede1] hover:text-orange transition-all duration-300">
                        View Orders
                      </button>
                    </Link>
                  </div>
                )}
              </>
            ) : (
              <>
                <p className="">Please reload page</p>
              </>
            )}
          </>
        ) : (
          <>
            <p className="text-grayish-blue my-8">
              Congratulation on your order. Be sure to check your emails for
              order updates.
            </p>
          </>
        )}
      </div>
    </section>
  );
};

export default PaymentSuccessful;
